/* eslint-disable no-unused-vars */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IPage } from 'src/interfaces';
import { RegularButton, CommonDropdown, WorkInProgress, ChartsCard } from 'pg-ui-library';
import { BenefitsTable, BulletinsTable, WarningsTable } from 'src/components';
import {
  BenefitsContainer,
  BenefitsHeader,
  BenefitsHeaderContainer,
  BenefitsSubHeader,
  BulletinsContainer,
  Container,
  ChartContainer,
  ChartContainerHeader,
  FirstItemsContainer,
  HeaderText,
  ItemsContainer,
  NumbersAtGlanceContainer,
  NumbersAtGlanceFooter,
  NumbersAtGlanceHeader,
  NumbersAtGlanceTotal,
  ThingsToDoBody,
  ThingsToDoContainer,
  ThingsToDoHeader,
  ThingsToDoText1,
  ThingsToDoText2,
  WarningsContainer,
  WarningsContainerHeader,
  YearEndFormsBody,
  YearEndFormsContainer,
  YearEndFormsHeader,
  ChartSliderContainer,
} from './styles';

import ThumbsUp from '../../assets/thumb_up.png';

import { dropdownOptions1, dropdownOptions2, mockChartEmployee, mockChartPayHistory } from './mocks/dashboard.mock';
import { DashboardChartSlider } from './components/slider';

const Dashboard: React.FC<IPage> = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <FirstItemsContainer>
        <ChartContainer>
          <ChartContainerHeader>{t('dashboard.employeePayHistory.header')}</ChartContainerHeader>
          <WorkInProgress />
          {/**
          <ChartsCard data={mockChartPayHistory} />
          <ChartSliderContainer>
            <DashboardChartSlider url="/pay-history" />
          </ChartSliderContainer>
          */}
        </ChartContainer>
        <WarningsContainer>
          <WarningsContainerHeader>
            <HeaderText>{t('dashboard.warnings.header')}</HeaderText>
          </WarningsContainerHeader>

          <WarningsTable />
        </WarningsContainer>
      </FirstItemsContainer>
      <ItemsContainer>
        <ThingsToDoContainer>
          <ThingsToDoHeader>{t('dashboard.thingsToDo.header')}</ThingsToDoHeader>
          {/**
           <ThingsToDoBody>
            <div>
              <img src={ThumbsUp} alt="thumbs" />
            </div>
            <ThingsToDoText1>{t('dashboard.thingsToDo.text1')}</ThingsToDoText1>
            <ThingsToDoText2>{t('dashboard.thingsToDo.text2')}</ThingsToDoText2>
          </ThingsToDoBody>
          */}

          <WorkInProgress />
        </ThingsToDoContainer>

        <ThingsToDoContainer>
          <HeaderText>{t('dashboard.bulletins.header')}</HeaderText>
          <BulletinsTable />
        </ThingsToDoContainer>
        <ThingsToDoContainer>
          <BenefitsHeaderContainer>
            <BenefitsHeader>{t('dashboard.benefits.header')}</BenefitsHeader>

            <BenefitsSubHeader>{t('dashboard.benefits.subheader')}</BenefitsSubHeader>
          </BenefitsHeaderContainer>
          <BenefitsTable />
        </ThingsToDoContainer>
      </ItemsContainer>
      <ItemsContainer>
        <ThingsToDoContainer>
          <NumbersAtGlanceHeader>{t('dashboard.activeEmployees.header')}</NumbersAtGlanceHeader>
          {/**
          <div>
            <NumbersAtGlanceTotal>1.234</NumbersAtGlanceTotal>
            <NumbersAtGlanceFooter>
              {t('dashboard.activeEmployees.footer')}
            </NumbersAtGlanceFooter>
          </div>
           */}
          <WorkInProgress />
        </ThingsToDoContainer>
        <ChartContainer style={{ minWidth: '500px' }}>
          <ChartContainerHeader>{t('dashboard.employees.header')}</ChartContainerHeader>
          {/**
          <ChartsCard data={mockChartEmployee} />
          <ChartSliderContainer>
            <DashboardChartSlider url="/employee" />
          </ChartSliderContainer>
           */}
          <WorkInProgress />
        </ChartContainer>
        <YearEndFormsContainer>
          <YearEndFormsHeader>{t('dashboard.yearEndForms.header')}</YearEndFormsHeader>
          {/**
          <YearEndFormsBody>
            <CommonDropdown
              label=""
              id="datePicker1"
              name="datePicker1"
              setValue={() => {}}
              options={dropdownOptions1}
              wrapperStyle={{ width: '70%' }}
              selectStyle={{ maxWidth: 'none', width: '100%' }}
            />

            <CommonDropdown
              label=""
              id="datePicker2"
              name="datePicker2"
              setValue={() => {}}
              options={dropdownOptions2}
              wrapperStyle={{ width: '20%' }}
              selectStyle={{ maxWidth: 'none', width: '100%' }}
            />
          </YearEndFormsBody>
           */}
          <WorkInProgress />
        </YearEndFormsContainer>
      </ItemsContainer>
    </Container>
  );
};

export default Dashboard;
